var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { useActionHandlers } from './actions';
import { useApiQuery } from '../../../infra/api';
import { endpoints } from '../network/endpoints';
import { mapSubToViewModel } from './map-subscription';
import { getSessionBrand, useSession } from '../../../infra/session';
import { SubscriptionMessagePopupView } from './subscription-message-popup';
import { useOnAfterRouteChange } from '../../../infra/routing';
import { cleanUpDismissals, shouldPathnameBeBlocked, shouldShowMessage } from './utils';
import { invalidateSubscriptionStatus } from '../network/endpoints/subscription-status-query';
export var SubscriptionMessageContainer = function () {
    var _a = useState(false), isVisible = _a[0], setIsVisible = _a[1];
    var session = useSession().data;
    var brand = session ? getSessionBrand(session) : null;
    var subStatusQuery = useApiQuery({
        endpoint: endpoints.subscriptionStatusQuery,
        payload: { brandId: brand === null || brand === void 0 ? void 0 : brand.id },
        options: { enabled: !!brand },
    });
    useEffect(function () {
        var nextVisibilityState = shouldShowMessage(subStatusQuery.data);
        setIsVisible(nextVisibilityState);
    }, [subStatusQuery.data]);
    useEffect(function () {
        return function () {
            cleanUpDismissals();
        };
    }, []);
    useOnAfterRouteChange(function (nextRoute) {
        var isNewRouteBlocked = shouldPathnameBeBlocked(nextRoute.pathname) && shouldShowMessage(subStatusQuery.data);
        if (isNewRouteBlocked) {
            // show the message if the latest known state was blocking
            // if the status after invalidation will not be blocking anymore, it will be hidden by useEffect
            setIsVisible(true);
            // invalidate the subscription status to make sure any updates made on the previous page are reflected
            invalidateSubscriptionStatus({ brandId: brand.id });
        }
    }, [brand === null || brand === void 0 ? void 0 : brand.id, subStatusQuery.data]);
    var actions = useActionHandlers(session, subStatusQuery.data, function () { return setIsVisible(false); });
    if (!isVisible) {
        return null;
    }
    var viewModel = mapSubToViewModel(subStatusQuery.data);
    return (_jsx(SubscriptionMessagePopupView, __assign({}, viewModel, { actionHandlers: actions.handlers, onSignOutClick: actions.dismissHandlers.signOut, onClose: actions.dismissHandlers.close, disabled: !!actions.pendingAction })));
};
